import { type EnvironmentConfig, RecordSource, Store } from 'relay-runtime';

import RelayDataID from '@atlassian/relay-data-id';
import RelayMissingFieldHandlers from '@atlassian/relay-missing-field-handlers';
import { network as defaultNetwork } from '@atlassian/relay-network';
import RelayScheduler from '@atlassian/relay-scheduler';

type Props = {
	log?: EnvironmentConfig['log'];
	requiredFieldLogger?: EnvironmentConfig['requiredFieldLogger'];
	network?: EnvironmentConfig['network'];
};

export const getDefaultRelayEnvironmentConfig = ({
	log,
	requiredFieldLogger,
	network,
}: Props): EnvironmentConfig => ({
	configName: 'Atlassian Graphql Gateway',
	network: network || defaultNetwork,
	store: new Store(new RecordSource(), {
		// @ts-expect-error - TS2345 - Argument of type '{ log: (event: LogEvent) => void; getDataID: (fieldValue: { [key: string]: unknown; }, typeName: string) => string | undefined; }' is not assignable to parameter of type '{ gcScheduler?: Scheduler | null | undefined; operationLoader?: OperationLoader | null | undefined; gcReleaseBufferSize?: number | null | undefined; queryCacheExpirationTime?: number | ... 1 more ... | undefined; }'.
		log,
		getDataID: RelayDataID,
	}),
	log,
	requiredFieldLogger,
	// Renamed https://github.com/facebook/relay/commit/914794c4ddba6f7c8d2469ecdc5aa42eb112a6bb
	// @ts-expect-error Object literal may only specify known properties, and 'relayFieldLogger' does not exist in type 'EnvironmentConfig'
	relayFieldLogger: requiredFieldLogger,
	getDataID: RelayDataID,
	scheduler: RelayScheduler,
	missingFieldHandlers: RelayMissingFieldHandlers,
});
